import React from 'react'
import { Link } from 'react-router-dom'

const SOCIAL_FACEBOOK = 'https://www.facebook.com/share/1HgBRKwosv/'
const SOCIAL_YOUTUBE = 'https://www.youtube.com/@urumavahini'

function FooterOne() {
    return (
        <footer className="footer-wrapper footer-layout1">
            <div className="widget-area">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-md-6 col-xl-3">
                            <div className="widget footer-widget">
                                <div className="th-widget-about">
                                    <div className="about-logo">
                                        <Link to="/">
                                            <img src="/assets/img/logo3.png" alt="Urumavahini" />
                                        </Link>
                                    </div>
                                    <p className="about-text">
                                        Explore heritage and nature with us. Travel with Dinesh, Ape Pansala,
                                        Urumaya, and Ranga Rata offer unique experiences across Sri Lanka.
                                    </p>
                                    <div className="th-social">
                                        <a
                                            href={SOCIAL_FACEBOOK}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Urumavahini on Facebook"
                                        >
                                            <i className="fab fa-facebook-f" />
                                        </a>
                                        <a
                                            href={SOCIAL_YOUTUBE}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Urumavahini on YouTube"
                                        >
                                            <i className="fab fa-youtube" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget widget_nav_menu footer-widget">
                                <h3 className="widget_title">Quick Links</h3>
                                <div className="menu-all-pages-container">
                                    <ul className="menu">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/#about">About Us</Link></li>
                                        <li><Link to="/travel-with-dinesh">Travel with dinesh</Link></li>
                                        <li><Link to="/ape-pansala">Ape pansala</Link></li>
                                        <li><Link to="/urumaya">Urumaya</Link></li>
                                        <li><Link to="/ranga-rata">Ranga Rata</Link></li>
                                        <li><Link to="/#contact">Contact us</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Contact</h3>
                                <div className="th-widget-contact">
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/phone.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p>
                                                <Link to="tel:+94728063369" className="info-box_link">
                                                    072 806 3369
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/envelope.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p>
                                                <Link
                                                    to="mailto:psd60154@gmail.com"
                                                    className="info-box_link"
                                                >
                                                    psd60154@gmail.com
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/location-dot.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p>160/3 A, Pahalayagoda, Ganemulla</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="copyright-wrap background-image"
                style={{ backgroundImage: "url('/assets/img/bg/copyright_bg_1.jpg')" }}
            >
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-12 text-center">
                            <p className="copyright-text">
                                © 2026 <Link to="/">Urumavahini</Link>. All Rights Reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </footer>

    )
}

export default FooterOne
